import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    LineChart,
	Line,
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ReferenceLine,
    Cell,
    Legend
  } from "recharts";
import ChartConfig, { tooltipStyle, tooltipTextStyle } from 'Constants/chart-config';

import { 
    allStudents,
    fetchTournamentChart,
 } from 'Actions';

class ViewReport extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            student:this.props.data.student, 
            loader:false,
            reportview:true,
            seldata:this.props.data.seldata,
            allcourse:this.props.data.allcourse, 
        };
    }

    selstudent = (evt) =>{
        var stdid =evt.value;
        this.setState({ student:stdid });
    }


    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });
        
    }    

    handleChange(event){
        event.preventDefault();
        var seldate=this.state.seldata;
        var alldate=seldate.join(',');
        var student=this.state.student;
        var course=event.target.value; 
        this.setState({ loader:true, reportview:false });
       
        this.props.fetchTournamentChart(student, alldate, course).then((data) => {   
                       
                this.setState({ 
                    loader:false,
                    reportview:true,
                 });
        });
        
    }
    
    


render() {

    const { studentlists, tournamentscorechart, loading} = this.props;   
    const linedata = tournamentscorechart.chartval; 
    const allposition= tournamentscorechart.position; 
    const allstudent=studentlists.map((stdval) => {  
        return {
           label: stdval.student,  
           value: stdval.uudID
        }
    });

    const styles = {
        table: {
            border: "2px solid rgb(0, 0, 0)",
            borderColor:"rgb(0 0 0 / 49%)",
            borderStyle:"solid",
            color:"#000"
        },
        tabletrtd: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            fontWeight: "500"
        },
        tabletrtdleft:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            width:"70%"
        },
        tabletrtdhead:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            fontWeight:"bold",
            textAlign:"center"
        }
    };
    
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
          return (
            <div className="custom-tooltip" style={{backgroundColor:"#fff", padding:"10px", fontSize:"10px"}}>
              <div className="label" style={{fontSize:"13px"}}><strong>{`${payload[0].payload?.tournament}`}</strong></div>
              <div className="label" style={{fontSize:"13px"}}><strong>{`${payload[0].payload?.course}`}</strong></div>
              <div className="label" style={{fontSize:"13px"}}>{`${payload[0].payload?.label}`} : <strong>{`${payload[0].payload?.y}`}</strong></div>
              <div className="label" style={{fontSize:"13px"}}>Position : <strong>{`${payload[0].payload?.position}`}</strong></div>
            </div>
          );
        }
      
        return null;
    };
    
      return(
        <div>
                    <div className="row">
                        <div className="col-sm-12 col-lg-12" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard>
                                <div className="row">
                                    <div className="col-sm-12 col-lg-6">
                                     <div className="row">  
                                        <div className="col-lg-3">Tournament</div>   
                                            <div className="col-lg-9">
                                                <select  name="tournament" className="form-control form-control-alternative" onChange={e => this.handleChange(e)}>
                                                    <option value="">All</option>
                                                    {this.state.allcourse.map((teamval, idx) => (                     
                                                        <option value={teamval.id}>{teamval.name}</option>                   
                                                    ))}                                          
                                                </select>
                                            </div>
                                        </div> 
                                    </div>   
                                    <div className="col-sm-12 col-lg-6">  
                                    <div className="ss">
                                    <button type="button" className="mr-10 mb-10 btn btn-outline-warning float-right" onClick={this.props.onClick} >Back</button>   
                                    </div>
                                    </div>
                                </div>
                                {this.state.reportview &&
                                <>
                                <div className="row">
                                    <div className="col-sm-12 col-lg-8">
                                    <ResponsiveContainer width={800} height={300} style={{margin:"1px"}}> 
                                        <LineChart data={linedata}>
                                            <XAxis dataKey="x" domain={[0, "auto"]} stroke={ChartConfig.axesColor} />
                                            <YAxis stroke={ChartConfig.axesColor}/>
                                            <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
                                            <Tooltip content={<CustomTooltip/>} />                                                            
                                            <Line type="bumpX" dataKey="y" stroke={ChartConfig.color.info} label={{ fill: '#757474', fontSize: 15, position:'top' }} dot={{ strokeWidth: 4 }} activeDot={{ r: 10 }} />
                                        </LineChart>
                                    </ResponsiveContainer>
                                    </div>
                                    <div className="col-sm-12 col-lg-4">
                                        <div className="table-responsive">
                                            <table className="table align-items-center table-flush" style={styles.table}>                        
                                                <tbody>
                                                    
                                                    <tr>
                                                        <td style={styles.tabletrtdleft}>SCORING AVG</td>
                                                        <td style={styles.tabletrtd}><strong>{tournamentscorechart.score}</strong></td>                                                
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tabletrtdleft}>R1 AVG</td>
                                                        <td style={styles.tabletrtd}><strong>{tournamentscorechart.r1}</strong></td>                                                
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tabletrtdleft}>R2 AVG</td>
                                                        <td style={styles.tabletrtd}><strong>{tournamentscorechart.r2}</strong></td>                                                
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tabletrtdleft}>R3 AVG</td>
                                                        <td style={styles.tabletrtd}><strong>{tournamentscorechart.r3}</strong></td>                                                
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tabletrtdleft}>R4 AVG</td>
                                                        <td style={styles.tabletrtd}><strong>{tournamentscorechart.r4}</strong></td>                                                
                                                    </tr>
                                                    <tr>
                                                        <td style={styles.tabletrtdleft}>MISS CUT AVG</td>
                                                        <td style={styles.tabletrtd}><strong>{tournamentscorechart.miss}%</strong></td>                                                
                                                    </tr>
                                                    
                                                </tbody>
                                            </table>    
                                        </div>  
                                    </div>
                                      
                                </div>  
                                <div className="row">
                                    
                                    <div className="col-sm-12 col-lg-6">
                                    <h2 className="text-center">POSITION LIST</h2>
                                        <div className="table-responsive">
                                            <table className="table align-items-center table-flush" style={styles.table}>                        
                                                <tbody>
                                                    <tr>
                                                        <td style={styles.tabletrtdhead}>TOURNAMENT</td>
                                                        <td style={styles.tabletrtdhead}>POSITION</td>                                                
                                                    </tr>
                                                    {allposition.map((element, i) => (
                                                        <tr>
                                                            <td style={styles.tabletrtd}>{element.tournament}</td>
                                                            <td style={styles.tabletrtd}>{element.position}</td>                                                
                                                        </tr>

                                                    ))}
                                                </tbody>
                                            </table>    
                                        </div>  
                                    </div>  
                                </div>  
                                </>
                                }
                            </RctCollapsibleCard>
                        </div>   
                    </div>
                

                {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                }
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused, tournamentscore}) => {
    const { studentlists, loading } = mostlyused;
    const { tournamentscorechart } = tournamentscore;
    return { studentlists, tournamentscorechart, loading };
   
}


export default connect(mapStateToProps, {
    allStudents,
    fetchTournamentChart,
})(ViewReport);
